// React imports
import React from 'react';
import { useNavigate } from 'react-router-dom';

// Context imports
import { useGlobalContext } from '../../context/GlobalStore';

// Material-UI imports
import InboxIcon from '@mui/icons-material/Inbox';
import MailIcon from '@mui/icons-material/Mail';
import { Box, Divider, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { styled } from '@mui/material/styles';

// Styled Drawer with animated gradient
const AnimatedDrawer = styled(Drawer)(({ theme }) => ({
  '& .MuiDrawer-paper': {
    background: 'linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab, #f093fb, #f5576c, #4facfe, #00f2fe)',
    backgroundSize: '400% 400%',
    animation: 'gradientShift 15s ease infinite',
    color: 'white',
    
    // Add text shadow for better readability
    '& .MuiListItemText-primary': {
      textShadow: '1px 1px 2px rgba(0,0,0,0.3)',
      fontWeight: 'bold'
    },
    
    // Hover effects for menu items
    '& .MuiListItemButton-root': {
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(10px)'
      }
    }
  },
  
  '@keyframes gradientShift': {
    '0%': {
      backgroundPosition: '0% 50%'
    },
    '50%': {
      backgroundPosition: '100% 50%'
    },
    '100%': {
      backgroundPosition: '0% 50%'
    }
  }
}));

/**
 * SideMenu Component
 * Navigation sidebar with animated gradient background
 */
export const SideMenu = () => {
  // Context hooks for state management
  const { state: globalState, action: globalActions } = useGlobalContext();
  const navigate = useNavigate();
  
  /**
   * Handle menu item click navigation
   * @param {string} path - Route path to navigate to
   */
  const handleMenuClick = (path) => {
    navigate(path);
    // Close sidebar after navigation on mobile
    globalActions.toggleSideMenu();
  };
  
  return (
    <>
      <AnimatedDrawer 
        anchor="left" 
        open={globalState.isSideMenuOpen} 
        onClose={globalActions.toggleSideMenu}
      >
        <Box sx={{ width: 250 }} role="presentation">
          <List>
            {/* Home Navigation Item */}
            <ListItem key="Home" disablePadding>
              <ListItemButton
                onClick={() => {
                  handleMenuClick('/');
                }}
              >
                <ListItemText primary="Home" />
              </ListItemButton>
            </ListItem>
            
            {/* Goals Navigation Item */}
            <ListItem key="Goals" disablePadding>
              <ListItemButton
                onClick={() => {
                  handleMenuClick('/goals');
                }}
              >
                <ListItemText primary="Goals" />
              </ListItemButton>
            </ListItem>
            
            {/* History Navigation Item */}
            <ListItem key="History" disablePadding>
              <ListItemButton
                onClick={() => {
                  handleMenuClick('/history');
                }}
              >
                <ListItemText primary="History" />
              </ListItemButton>
            </ListItem>
          </List>
        </Box>
      </AnimatedDrawer>
    </>
  );
};
